import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface ISkeletonTemplate {
	fullWidth?: boolean;
	rowNumber?: number;
	type?: 'card' | 'product';
	hasDescription?: boolean;
}

export const SkeletonTemplate = ({ rowNumber = 3, type, hasDescription, fullWidth = false }: ISkeletonTemplate) => {
	//this is probably not the final version and can be improved - the card skeleton template
	if (type === 'card') {
		return (
			<div
				className={`overflow-hidden  grid gap-x-1.5 gap-y-3 md:gap-5 md:justify-center md:self-center ${
					rowNumber <= 2
						? `grid-cols-2 ${fullWidth ? 'w-full' : 'md:w-6/12'}`
						: `grid-cols-2 grid-rows-2 md:grid-cols-3 ${fullWidth ? 'w-full' : 'md:w-10/12'}`
				}`}>
				{[...Array(rowNumber)].map((_, id) => (
					<div key={id} className="bg-white px-4 py-3 flex-1 text-center rounded">
						<Skeleton className="rounded w-[106px] h-[106px] mb-2" />
						<Skeleton className="rounded h-[25.2px] md:h-[28px] mb-2" />
						{hasDescription && <Skeleton className="rounded h-0 md:h-[110px]" />}
					</div>
				))}
			</div>
		);
	}
	if (type === 'product') {
		return (
			<div className="overflow-hidden flex flex-col justify-center gap-5">
				{[...Array(rowNumber)].map((_, id) => (
					<div key={id} className="bg-white p-4 rounded h-[100px] md:h-fit flex items-center">
						<Skeleton className="hidden md:inline-flex md:mr-4" width={70} height={70} />
						<div className="flex flex-col gap-1.5 w-full">
							<Skeleton className="rounded h-[29px]" width="100%" />
							<Skeleton className="rounded h-[22.4px]" width={200} />
						</div>
					</div>
				))}
			</div>
		);
	}
	return (
		<div className="overflow-hidden flex flex-col justify-center">
			{[...Array(rowNumber)].map((_, id) => (
				<div key={id} className="bg-white px-4 py-3 first:rounded-t last:rounded-b h-[100px] md:h-fit">
					<Skeleton className="rounded h-[25.2px] md:h-[28px]" />
					<Skeleton className="rounded h-[22.4px] ml-5" width={150} />
				</div>
			))}
		</div>
	);
};
